import { EntityLayout } from '@backstage/plugin-catalog';
import { EntityGroupProfileCard, EntityMembersListCard } from '@backstage/plugin-org';
import { Grid } from '@material-ui/core';
import React from 'react';

type NonPeopleAppGroupPageProps = {
  entityWarningContent: JSX.Element;
};

export const NonPeopleAppGroupPage = ({
  entityWarningContent,
}: NonPeopleAppGroupPageProps) => {
  
  return (
    <EntityLayout>
      <EntityLayout.Route path="/" title="Overview">
        <Grid container spacing={3}>
          {entityWarningContent}
          <Grid item xs={12} md={12}>
            <EntityGroupProfileCard />
          </Grid>
          <Grid item xs={12} md={12}>
            <EntityMembersListCard />
          </Grid>
        </Grid>
      </EntityLayout.Route>
    </EntityLayout>
  );
};
